import MockAdapter from 'axios-mock-adapter';

export default function (axios) {
  const mock = new MockAdapter(axios);

  // mock.onPost('/index.php/business/interface-list').reply(500, {
  //   data: {
  //     msg: '错误'
  //   }
  // })
};



// WEBPACK FOOTER //
// ./src/axios/mockConfig.js